import { useState, useEffect, useRef } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useLanguage } from '../../context/LanguageContext/LanguageContext';
import logoImg from './logo.png';
import './Navbar.css';

const LANGUAGES = [
  { code: 'zh-CN', label: '简体中文' },
  { code: 'zh-TW', label: '繁體中文' },
  { code: 'en', label: 'English' },
];

function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isLangOpen, setIsLangOpen] = useState(false);
  const location = useLocation();
  const { language, setLanguage, t } = useLanguage();
  const langRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (langRef.current && !langRef.current.contains(e.target)) {
        setIsLangOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const navItems = [
    { path: '/', label: t.nav.home },
    { path: '/about', label: t.nav.about },
    { path: '/services', label: t.nav.services },
    { path: '/pricing', label: t.nav.pricing },
    { path: '/news', label: t.nav.news },
    { path: '/contact', label: t.nav.contact },
  ];

  const currentLang = LANGUAGES.find((l) => l.code === language);

  return (
    <nav className={`navbar ${isScrolled ? 'scrolled' : ''}`}>
      <div className="container navbar-container">
        <Link to="/" className="logo">
          <img src={logoImg} alt="logo" className="logo-icon" />
          <span className="logo-text">{t.nav.logoText}</span>
        </Link>

        <button
          className="mobile-menu-toggle"
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          aria-label="Toggle menu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>

        <ul className={`nav-links ${isMobileMenuOpen ? 'active' : ''}`}>
          {navItems.map((item) => (
            <li
              key={item.path}
              className={
                item.path === '/about' || item.path === '/pricing'
                  ? 'has-dropdown'
                  : ''
              }
            >
              <Link
                to={item.path}
                className={location.pathname === item.path ? 'active' : ''}
                onClick={() => setIsMobileMenuOpen(false)}
              >
                {item.label}
              </Link>
              {item.path === '/about' && (
                <ul className="nav-dropdown">
                  <li>
                    <Link
                      to="/credentials"
                      onClick={() => setIsMobileMenuOpen(false)}
                    >
                      🏆 {t.nav.credentials}
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/careers"
                      onClick={() => setIsMobileMenuOpen(false)}
                    >
                      💼 {t.nav.careers}
                    </Link>
                  </li>
                </ul>
              )}
              {item.path === '/pricing' && (
                <ul className="nav-dropdown">
                  <li>
                    <Link
                      to="/downloads"
                      onClick={() => setIsMobileMenuOpen(false)}
                    >
                      📥 {t.nav.downloads}
                    </Link>
                  </li>
                </ul>
              )}
            </li>
          ))}
        </ul>

        <div className="lang-switcher" ref={langRef}>
          <button
            className="lang-toggle"
            onClick={() => setIsLangOpen(!isLangOpen)}
            aria-label="Switch language"
          >
            🌐 {currentLang.label}
            <span className={`lang-arrow ${isLangOpen ? 'open' : ''}`}>▾</span>
          </button>
          {isLangOpen && (
            <ul className="lang-dropdown">
              {LANGUAGES.map((lang) => (
                <li key={lang.code}>
                  <button
                    className={language === lang.code ? 'active' : ''}
                    onClick={() => {
                      setLanguage(lang.code);
                      setIsLangOpen(false);
                    }}
                  >
                    {lang.label}
                  </button>
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
